import {Component} from '@angular/core';
import {FormBaseComponent, ValidatorService} from '@utils-lib';
import {Betriebstaette, LohnsteuerAngaben} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'common-ui-beginn-lohnzahlungen',
  templateUrl: './beginn-lohnzahlungen.component.html'
})
export class BeginnLohnzahlungenComponent extends FormBaseComponent<LohnsteuerAngaben> {

  public betriebstaetten: Array<Betriebstaette> = [];

  constructor(private readonly formBuilder: FormBuilder,
              private readonly validatorService: ValidatorService,
              protected readonly messageService: DatevMessageService,
              protected readonly translateService: TranslateService) {
    super(messageService);
  }

  protected createForm(): void {
    this.form = this.formBuilder.group({
      beginnLohnzahlungen: [
        this.data.beginnLohnzahlungen, [
          this.validatorService.date(),
          this.validatorService.required()
        ]]
    });
  }


}

